export default "__VITE_ASSET__b6ec4a36__"